import contactLaunchScreenImage from "data-url:/assets/img/contact-launch-dummy.png";
import sheetMaskImage from "data-url:/assets/img/sheet-mask.svg";

export {
  contactLaunchScreenImage,
  sheetMaskImage
};
